
import { Component, Vue, Watch } from 'vue-property-decorator';
import MOMABffService from '@/services/moma-bff.service';

@Component
export default class ResponsibilityTermGate extends Vue {
  private show = false;
  private accepted = false;
  private bff = new MOMABffService();

  get user() {
    return this.$store.state.user.currentUser;
  }

  mounted() {
    this.updateFromUser();
  }

  @Watch('user', { immediate: false, deep: false })
  onUserChanged() {
    this.updateFromUser();
  }

  private updateFromUser() {
    this.show = !!this.user && !this.user.isResponsibilityTermSigned;
  }

  private async confirmResponsibility() {
    if (!this.accepted) return;
    await this.bff.signResponsibilityTerm();
    const updated = { ...this.user, isResponsibilityTermSigned: true };
    this.$store.commit('user/SET_CURRENT_USER', updated);
    this.show = false;
  }
}
